import Bao from "../../services/bao-service";
import * as $ from "jquery";
import * as ko from "knockout";
import GenericListTab from "../../factories/generic-list-tab";
import BaoDialog from "../../factories/bao-dialog";
import TabPage from "../../factories/tab-page";
import RoleShiftbookTabDialog from "../master-data/tabs/role-shiftbook-tab-dialog";

/**
 * ViewModel for the Roles tab in the Shiftbook
 * */
class ShiftbookRole extends GenericListTab {
    Bao = Bao;
    DialogWidth = 800;
    /** used in dialog to control detail view is on/off */
    DetailedView = ko.observable(false);
    /** used in dialog to control detail view is on/off */
    toggleDetailedView = () => { this.DetailedView(!this.DetailedView()); }
    /** used in manual foreach selection table */
    SelectedRow = ko.observable({});
    roleShiftbookDialog: RoleShiftbookTabDialog = null;

    IsShiftbookTypeIsShiftbook: KnockoutObservable<boolean> = ko.observable(false);
    IsShiftbookTypeIsInstruction: KnockoutObservable<boolean> = ko.observable(false);
    IsShiftbookTypeIsTask: KnockoutObservable<boolean> = ko.observable(false);
    IsShiftbookTypeIsWhiteboard: KnockoutObservable<boolean> = ko.observable(false);
    IsShiftbookTypeIsBriefing: KnockoutObservable<boolean> = ko.observable(false);
    IsShiftbookTypeIsWorkItemTaskBook: KnockoutObservable<boolean> = ko.observable(false);

    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SetIsShiftbookTypes(ko.unwrap(parent.ShiftbookTypeKey));

        this.Models.subscribe(() => {
            this.Selection([]);
        });
        this.SelectedRow.subscribe((value) => {
            this.Selection([value]);
        });
    }

    CustomFilter(): Models.HashObject[] {
        return null;
    }

    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        if (!item.RoleId()) {
            def.resolve(false);
        }
        else {
            def.resolve(true);
        }

        return def.promise();
    }

    /**
 * ko data-bind click event on shiftbookname
 * @param data
 * @param event
 */
    OnClickRoleName(data, event) {
        this.OpenEditDialog(ko.unwrap(data.PrimaryKeyValue));
    }
    /**
     * ko data-bind click event on dialog's detail button
     * @param data
     * @param event
     */
    OnClickDetailButton(data, event) {
        this.toggleDetailedView();
    }

    /**
     * opens the dialog, checks the edit permission before
     * @param primaryKeyValue
     */
    private OpenEditDialog(primaryKeyValue: string) {
        // check if btn "edit" is available (permitted) and cancel if not
        if (!this.ToolbarButtons().filter(x => ko.unwrap(x.ActionKey) === this.PermissionEdit).map(x => ko.unwrap(x.Visible))[0]) {
            return;
        }
        this.Dialog(ko.unwrap(primaryKeyValue));
    }

    /**
     * overrides GenericListTab's Dailog Method
     * @param itemId
     */
    Dialog(itemId: string) {
        // need to set DetailedView to false (=default), before calling the base method
        this.DetailedView(false);
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: itemId
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                const item: RoleShiftbookTabDialog = dialog.ViewModel();
                this.ItemCompleteCheck.call(this, item).then((validateResult) => {
                    if (validateResult) {
                        const modelToSave = this.roleShiftbookDialog.GetModelToSave();
                        this.Save(modelToSave).then(() => {
                            this.TabPage.DirtyFlag(true);
                            dialog.Close();
                        });
                    }
                    else {
                        new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSelectRole"), "info");
                    }
                });
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            var vm = ko.map.fromJS(result.Model);
            vm.Parent = this;
            vm.TabModel = (<any>result).TabModels;
            vm.fromShiftbook = true;
            this.roleShiftbookDialog = new RoleShiftbookTabDialog(vm, dialog);
            dialog.ViewModel(this.roleShiftbookDialog);
            dialog.Template(result.Template);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }

    /**
 * overrides GenericListTab.Save to check the server response
 * @param item
 */
    public Save(item) {
        this.TabPage.IsLoading(true);
        return Bao.post('UadmFinitoCustom/RoleShiftbookTab/SaveAllTabs', JSON.stringify({
            sessionTabId: this.SessionTabId,
            mainDialogModel: item.mainDialogModel,
            generalTabModel: item.generalTabModel,
            roleShiftbookTabModel: item.roleShiftbookTabModel
        })).then((serverResult) => {
            if (serverResult) {
                if (serverResult.Result === false) {
                    new BaoDialog(null, serverResult.Message, "info");
                    // hack because the caller requires that this function uses an async this.Get() to unset IsLoading
                    window.setTimeout(() => {
                        this.TabPage.IsLoading(false);
                    }, 100);

                    return;
                }
            }
            return this.Get();
        }).always(_ => this.TabPage.IsLoading(false));
    };

    private SetIsShiftbookTypes(shiftbookTypeKey: string) {
        switch (shiftbookTypeKey) {
            case "ShiftBook":
                this.IsShiftbookTypeIsShiftbook(true);
                break;
            case "InstructionBook":
                this.IsShiftbookTypeIsInstruction(true);
                break;
            case "TaskBook":
                this.IsShiftbookTypeIsTask(true);
                break;
            case "Whiteboard":
                this.IsShiftbookTypeIsWhiteboard(true);
                break;
            case "Briefing":
                this.IsShiftbookTypeIsBriefing(true);
                break;
            case "WorkItemTaskbook":
                this.IsShiftbookTypeIsWorkItemTaskBook(true);
                break;
            default:
        }
    }
}
export default ShiftbookRole;